import React from 'react';

import * as Styled from './styles';

import { TableCellProps } from './types/TableCell.types';

const TableCell: React.FC<TableCellProps> = (props) => {
  const preventRowNavigationIfInteractive = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const interactiveSelector =
      'button, input, textarea, select, [data-prevent-row-link], [role="button"]';
    if (target.closest(interactiveSelector)) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <Styled.TableCell as={props.tag as never | undefined} {...{ ...props }}>
      {props.to ? (
        <Styled.LinkedCell
          to={props.to}
          state={props.state}
          onClick={preventRowNavigationIfInteractive}
        >
          {props.children}
        </Styled.LinkedCell>
      ) : (
        props.children
      )}
    </Styled.TableCell>
  );
};

export default TableCell;
